












import Vue from 'vue'
import { adjustDateTimeToJp } from '@/utils'
import SquareButton from '@/components/atoms/SquareButton.vue'

export default Vue.extend({
  name: 'UseButton',
  components: {
    SquareButton
  },
  props: {
    text: {
      type: String,
      required: true
    },
    status: {
      type: Boolean,
      required: false,
      default: false
    },
    date: {
      type: String,
      required: false,
      default: ''
    },
    buttonText: {
      type: String,
      required: true
    },
    buttonColor: {
      type: String,
      required: false,
      default: 'primary',
      validator: function(value: string) {
        return ['primary', 'reverse', 'gray'].indexOf(value) !== -1
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    adjustDateTimeToJp(): string {
      return adjustDateTimeToJp(this.date)
    }
  },
  methods: {
    handleClick() {
      this.$emit('handleClick')
    }
  }
})
